import React, { useState } from 'react';
import Lottie from 'react-lottie';
import backgroundImage from '../background.webp';
import cardbackground from '../cardbackground.webp'; // Import card background image
import buttonImage from '../buttonimage.webp'; // Add this import
import { supabase } from '../supabaseClient';
import animation1 from '../assets/animations/Animation - 1746549903589.json';
import animation2 from '../assets/animations/Animation - 1746550003901.json';
import animation3 from '../assets/animations/Animation - 1746550147637.json';
import animation4 from '../assets/animations/Animation - 1746550211721.json';
import animation5 from '../assets/animations/Animation - 1746550261015.json';
import animation6 from '../assets/animations/Animation - 1746550293247.json';
import animation7 from '../assets/animations/Animation - 1746550335162.json';
import animation8 from '../assets/animations/Animation - 1746550392848.json';
import animation9 from '../assets/animations/Animation - 1746549835764.json';

export default function Celebrate({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage/celebrate',
                    animated_helper: 'no', // <-- ensure this is always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '600px',
        height: 'auto',
        backgroundImage: `url(${cardbackground})`, // Use imported card background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px', // Add space between cards
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '10px',
        boxSizing: 'border-box',
    };

    const cardTextStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '16px',
        fontWeight: 'normal',
        color: 'black',
    };

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3 items per row
        gap: '20px', // Adjusted spacing between items
        marginTop: '10px',
    };

    const itemStyle = {
        width: '80px', // Increased size for better visibility
        height: '80px',
        cursor: 'pointer',
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    };

    const lottieAnimations = [
        { id: 1, animationData: animation1 },
        { id: 2, animationData: animation2 },
        { id: 3, animationData: animation3 },
        { id: 4, animationData: animation4 },
        { id: 5, animationData: animation5 },
        { id: 6, animationData: animation6 },
        { id: 7, animationData: animation7 },
        { id: 8, animationData: animation8 },
        { id: 9, animationData: animation9 },
    ];

    const [activeItem, setActiveItem] = useState(null);

    const handleItemClick = (id) => {
        setActiveItem(id);
        setTimeout(() => setActiveItem(null), 8000); // Reset after 8 seconds
    };

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px',
            }}
        >
            <h2
                style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '36px',
                    fontWeight: 'bold',
                    color: '#4B5563',
                    textAlign: 'center',
                    marginTop: '16px',
                }}
            >
                Celebrate
            </h2>
            <div style={cardStyle}>
                <p style={cardTextStyle}>
                    Look at how far you have come! You have handled everything you traversed on your way to this moment. Wow! That is worth Celebrating with a moment of appreciation and gratitude for your efforts and resilience.
                </p>
            </div>
            <div style={cardStyle}>
                {/* Visually hidden screen reader message for ADA compliance */}
                <span style={{
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0,0,0,0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }} aria-hidden="false" id="celebrate-lottie-desc">
                    The following grid contains clickable animated images (Lottie animations) that show celebratory moments. These are for visual celebration and fun.
                </span>
                <div style={gridStyle} aria-describedby="celebrate-lottie-desc">
                    {lottieAnimations.slice(0, 9).map((item) => (
                        <div
                            key={item.id}
                            style={itemStyle}
                            onClick={() => handleItemClick(item.id)}
                        >
                            <Lottie
                                options={{
                                    loop: false,
                                    autoplay: activeItem === item.id,
                                    animationData: item.animationData,
                                    rendererSettings: {
                                        preserveAspectRatio: 'xMidYMid slice',
                                    },
                                }}
                                height={80}
                                width={80}
                                isStopped={activeItem !== item.id}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div style={cardStyle}>
                <p style={cardTextStyle}>
                    I never knew the importance of Celebration in my spiritual process until I came across a spiritual teacher who said that celebrating how far we have come is a way to stabilize ourselves and solidify our accomplishments to that point. At least that was my interpretation of what he was saying. I felt confused about it more than anything. I like to know the why and the how he came to that conclusion, and he wasn't a teacher that shared in that way. So, I waited to see if I came to the same conclusion through experimenting with my own process. When I added in Celebration to my day, to my accomplishments, and to my memories it felt right. That is all I can say about it. It felt good to celebrate even the little things. It felt good to recognize myself for how far I have come.
                </p>
                <p style={cardTextStyle}>
                    For that reason, I am sharing the concept of celebrating as a tool for self love. May we each privately and publicly celebrate how far we have come often and freely, as needed.
                </p>
                <p style={cardTextStyle}>
                    What comes to mind when you search for something to celebrate right now? Do you feel good about celebrating how far you have come?
                </p>
            </div>
            <div
                className="celebrate-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginBottom: '16px',
                    marginTop: '0',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={handleSaveProgress}
                >
                    Save
                </button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .celebrate-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}
